module.exports = __webpack_public_path__ + "img/cod-badge.009ecc95.svg";